import { render, staticRenderFns } from "./EditGeocerca.vue?vue&type=template&id=20e0d5f2"
import script from "./EditGeocerca.vue?vue&type=script&lang=js"
export * from "./EditGeocerca.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./EditGeocerca.vue?vue&type=style&index=1&id=20e0d5f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports